import chargeStandard from './chargeStandard';
import getInvoicingNumber from './getInvoicingNumber';

export default {
	namespaced: true,
	state: {
		...chargeStandard.state,
		...getInvoicingNumber.state,
	},
	mutations: {
		...chargeStandard.mutations,
		...getInvoicingNumber.mutations,
	},
	actions: {
		...chargeStandard.actions,
		...getInvoicingNumber.actions,
	},
};
